module.exports = __webpack_public_path__ + "img/delivery-box.3b2c17b6.png";